import Bell from "@spectrum-icons/workflow/Bell";
import React, { useState } from "react";
import { FaRegFilePdf } from "react-icons/fa";
import PropTypes from "prop-types";
import "./NotificationBar.css";

const NotificationSidebar = ({ title, notifications, connectionStatus, onNotificationClick, showPDFIcon, loadingNotification }) => {
  const [isOpen, setIsOpen] = useState(true);

  const normalize = (val) => {
    if (!val) return [];
    return Array.isArray(val) ? val : [val];
  };

  return (
    <>
      <div className="chatbot-icon" onClick={() => setIsOpen((prev) => !prev)}>
        <Bell UNSAFE_className="notification_icon" />
      </div>

      {isOpen && (
        <div className="sidebar fade-in">
          <div className="sidebar-header">
            <div
              className="connection-status"
              style={{ backgroundColor: connectionStatus || "grey" }}
            />
            <span style={{ maxWidth: "260px" }}>{title || "Notifications"}</span>
            <button className="minimize-btn" onClick={() => setIsOpen(false)}>
              &minus;
            </button>
          </div>

          <div id="notifications" className="list-group">
            {notifications.length === 0 ? (
              <div className="notification empty">No notifications yet</div>
            ) : (
              notifications.map((n, idx) => (
                <div key={idx} className={`notification fade-in ${n.type}`} onClick={() => !loadingNotification && n.type === 'success' && onNotificationClick(n.originalUrls)}>
                  <div className="notification-title"
                    style={{
                      filter: loadingNotification && loadingNotification === n.originalUrls ? "blur(2px)" : "none",
                      opacity: loadingNotification && loadingNotification === n.originalUrls ? 0.5 : 1,
                      transition: "filter 0.2s, opacity 0.2s",
                    }}>{n.title}</div>

                  {n.type === "inProgress" && n.urls?.length > 0 && (
                    <ul>
                      {normalize(n.urls).map((url, i) => (
                        <li key={i} style={{ "word-wrap": "break-word" }}>
                          {url}
                        </li>
                      ))}
                    </ul>
                  )}

                  {n.type === "error" && n.urls?.length > 0 && (
                    <ul>
                      {normalize(n.urls).map((url, i) => (
                        <li key={i} style={{ "word-wrap": "break-word" }}>
                          {url}
                        </li>
                      ))}
                    </ul>
                  )}

                  {n.type === "success" && (
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          wordWrap: "break-word",
                          gap: "6px",
                          filter: loadingNotification && loadingNotification === n.originalUrls ? "blur(2px)" : "none",
                          opacity: loadingNotification && loadingNotification === n.originalUrls ? 0.5 : 1,
                          transition: "filter 0.2s, opacity 0.2s",
                        }}
                      >
                        {showPDFIcon && (
                          <FaRegFilePdf style={{ fontSize: "24px", color: "red", flexShrink: 0 }} />
                        )}
                        <span style={{ wordBreak: "break-word" }}>{n.urls}</span>
                      </div>

                      {loadingNotification && loadingNotification === n.originalUrls && (
                        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div className="notification-spinner" />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>

          <div className="footer">Live updates</div>
        </div>
      )}
    </>
  );
};

NotificationSidebar.propTypes = {
  title: PropTypes.string,
  connectionStatus: PropTypes.string,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["inProgress", "success", "error"]).isRequired,
      title: PropTypes.string.isRequired,
      urls: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
      ]),
      time: PropTypes.string,
    })
  ),
};

export default NotificationSidebar;
